import { BackendResponse } from "../BackendResponse";

export interface AddFavoriteToCandidateResponse extends BackendResponse {}

export interface AddFavoriteToCandidateParameters {
  idConcern: number;
  idCandidate: number;
  typeRelated: number;
  idRelated: number;
}

export type addFavoriteToCandidate = (
  args: AddFavoriteToCandidateParameters
) => Promise<AddFavoriteToCandidateResponse>;

export const addFavoriteToCandidate: addFavoriteToCandidate = async (args) => {
  throw new Error("not implemented");
};
